<template>
  <div>
    <b-card class="col-12" no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="12">
            <h4>
              Đăng ký gói cước
            </h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="2" sm="6">
            <validation-provider #default="{ errors }" :rules="''" name="Số điện thoại">
              <b-form-group label="Số điện thoại">
                <b-form-input v-model="packageParams.msisdn" :state="errors.length > 0 ? false:null"/>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="2" sm="6">
            <validation-provider #default="{ errors }" :rules="''" name="Gói cước">
              <b-form-group label="Gói cước">
                <Select2 v-model="packageParams.packageCode" :options="packageCodes"
                         :state="errors.length > 0 ? false:null"/>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="8" sm="12">
            <validation-provider #default="{ errors }" :rules="''" name="Ghi chú">
              <b-form-group label="Ghi chú">
                <b-form-input v-model="packageParams.note" :state="errors.length > 0 ? false:null"/>
              </b-form-group>
            </validation-provider>
          </b-col>

        </b-row>
        <b-row>
          <b-col class="text-end mb-2" cols="12">
            <b-button class="btn mx-2" variant="primary" @click="commit()">
              Đăng ký
            </b-button>
            <b-button class="btn" variant="primary" @click="onShowLog()">
              Tra cứu
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-card class="col-12" no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="9">
            <h4>
              Lịch sử đăng ký gói cước
            </h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <vue-good-table :columns="fields" :isLoading.sync="isLoading" :line-numbers="true"
                            :pagination-options="{ perPage: serverParams.pageSize, enabled: true }" :rows="tableData"
                            :totalRows="totalRecords" mode="remote"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange">
              <template slot="table-row" slot-scope="props">
                <span>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal
        id="modal-log"
        :title="'Kết quả gọi topop vnpay'"
        ok-only
        ok-title="Đóng"
        size="xl"
    >
      <template>

        <b-row>
          <b-col cols="12">
            <vue-good-table :columns="logFields" :line-numbers="true" :rows="topupLog">
              <template slot="table-row" slot-scope="props">
                <span>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>
<script>


import {ValidationObserver, ValidationProvider} from 'vee-validate'
import vSelect from 'vue-select'
import {VueGoodTable} from 'vue-good-table'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip
} from 'bootstrap-vue'
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from 'vue-ripple-directive'
import '@core/scss/vue/libs/vue-good-table.scss';
import Select2 from 'v-select2-component';
import moment from 'moment';
import flatPickr from 'vue-flatpickr-component'
import Vue from "vue"
import VueExcelXlsx from 'vue-excel-xlsx'

Vue.use(VueExcelXlsx)

export default {

  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BCardText,
    BInputGroup,
    flatPickr
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  async mounted() {
    await this.getPackage();
    await this.getTabTableData();
  },
  computed: {
    getStatus() {
      return this.selectedTab;
    },
    disabledModalField() {
      return this.selectedRecord && (this.selectedRecord.Status != 0)
    }
  },
  watch: {},
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      if (this.serverParams.columnFilters.Status == "") {
        delete this.serverParams.columnFilters.Status
      }
    },
    async onPageChange(params) {
      this.serverParams.page = params.currentPage
      this.serverParams.currentPage = params.currentPage
      await this.getTabTableData(true)
    },
    onSortChange(params) {
      this.updateParams(params);
      this.getTabTableData(false);
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.getTabTableData(false);
    },
    async onPerPageChange(params) {
      this.serverParams.pageSize = params.currentPerPage
      await this.getTabTableData(true)
    },
    async onShowLog() {
      await this.getTabTableData(true)
    },
    async commit() {
      var res = await this.$bvModal.msgBoxConfirm(
          "Bạn có chắc chắn đăng ký gói cho khách hàng?",
          {title: "Vui lòng xác nhận", size: "sm"}
      );
      if (res) {
        useJwt.post('pp/package', this.packageParams)
            .then(async response => {
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Đăng ký gói thành công!', icon: 'CheckSquareIcon', variant: 'success'}
              })
              await this.getTabTableData();
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {title: error.response.data.message, icon: 'AlertTriangleIcon', variant: 'danger'}
              })
            })
      }
    },
    async onApprove(row) {
      this.selectedRecord = JSON.parse(JSON.stringify(row));
      let data = {
        "Id": this.selectedRecord.Id
      }
      var res = await this.$bvModal.msgBoxConfirm(
          "Bạn có chắc chắn phê duyệt trả thưởng cho khách hàng?",
          {title: "Vui lòng xác nhận", size: "sm"}
      );
      if (res) {
        useJwt.post('aff/approve', data)
            .then(async response => {
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Phê duyệt thành công!', icon: 'CheckSquareIcon', variant: 'success'}
              })
              await this.getTabTableData();
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Phê duyệt không thành công!', icon: 'AlertTriangleIcon', variant: 'danger'}
              })
            })
      }
    },
    async getPackage() {
      var response = await useJwt.get('pp/package');
      if (response.data.code == 200) {
        this.packageCodes = response.data.result;
      } else {
        this.packageCodes = [{id: -1, text: 'Loading...'}]
      }

      response = await useJwt.get('aff/meta');
      if (response.data.code == 200) {
        this.status = [{id: -1, text: 'Tất cả'}, ...response.data.result.Status];
      } else {
        this.status = [{id: -1, text: 'Tất cả'}]
      }
    },
    getFieldsTable(columns) {
      this.fields = columns.map(c => {
        const key = Object.keys(c)[0];
        return {
          field: key,
          filterOptions: {enabled: true, placeholder: ''},
          label: c[key],
          required: true,
          disabled: true,
          tdClass: 'text-center',
          width: key === "ID" ? '50px' : key === "Status" ? "180px" : "auto"
        }
      })
    },
    async getTabTableData(isGetColumn = true) {
      this.tableData = [];
      this.totalRecords = 0
      const response = await useJwt.post(`pp/history/${this.packageParams.msisdn}`, this.serverParams);
      if (response.data.code == 200) {
        this.tableData = response.data.result ? response.data.result : []
        this.totalRecords = response.data.totalRecords
        if (isGetColumn) {
          this.getFieldsTable(response.data.extra.Column)
        }
      } else {
        if (isGetColumn) {
          this.getFieldsTable(response.data.extra.Column)
        }
        this.tableData = [];
        this.totalRecords = 0
      }
    },
    async changeTab(e) {
      this.selectedTab = e;
      await this.getTabTableData();
    },
    getDateTime(e) {
      return moment(e).isValid() ? moment(e).format('DD/MM/YYYY HH:mm:ss') : ''
    },
  },
  data() {
    return {
      packageCodes: [],
      selectedTab: -1,
      packageParams: {},
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50
      },
      totalRecords: 0,
      isLoading: false,
      group: [],
      status: [],
      tableData: [],
      exportTableData: [],
      selectedRecord: null,
      logContent: null,
      topupLog: [],
      fields: [{
        field: 'action',
        filterOptions: {enabled: false, placeholder: ''},
        label: 'Thao tác',
        required: true,
        disabled: true,
        width: '100px'
      }],
      logFields: [
        {
          label: 'Thời gian',
          field: 'LogDate',
        },
        {
          label: 'Nội dung',
          field: 'Content',
        }
      ]
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.modal-activated-order {
  height: 700px;
  color: #000000;
}

.col-700-scroll {
  height: 680px;
  overflow: auto;
}
</style>
<style scoped>
.error-txt small {
  color: red;
}

.text-end {
  text-align: end;
}

.action-col {
  width: 100%;
  display: flex;
  justify-content: center;
}

.detail-custom-table th,
.detail-custom-table td {
  border: solid 1px rgb(207 207 207);
  padding: 5px 10px;
}

.detail-custom-table th {
  vertical-align: baseline;
}

.history-call__header h5 {
  margin: 0;
}
</style>
